import { RoleFormItem } from 'assets/js/pages/account-settings/users/types';
import { AccountMemberOrInvite, AccountMemberRoleId, AccountMenuAccess } from 'types/domain';

const checkIfMe = (member: AccountMemberOrInvite, access: AccountMenuAccess) =>
    member.morph_type === 'account_member' && member.account_member_id === access.account_member_id;

const campaignSelectionToRequestValue = (campaigns: string[]) =>
    campaigns.length === 0 ? null : campaigns.map(Number);

const getRoleIdsForSubmission = (roles: RoleFormItem[]): AccountMemberRoleId[] => {
    return roles.filter(role => role.userCanAssign && role.checked).map(role => role.id);
};

export { checkIfMe, getRoleIdsForSubmission, campaignSelectionToRequestValue };
